import React, { useEffect, useState } from 'react';
import { TrimUiManager } from '../../../../../../trim-editor/manager/ui/trim.ui.manager';
import { StaticTooltip } from '../../../../../ui/tooltip/static-tooltip';
import '../print-trim.editor.scss'

type ShowTooltipType = 'imageHover' | 'frameMove' | 'scaleIcon' | 'rotateIcon' | 'none';

export const PrintTrimEditorToolTip = () => {
  // - State -
  // -- ツールチップ表示する種類 --
  const [showType, setShowType] = useState<ShowTooltipType>('none');
  // -- ツールチップの各表示位置 --
  const [imageHoverPos, setImageHoverPos] = useState<{ x: string, y: string }>({ x: '0', y: '0' });
  const [frameMovePos, setFrameMovePos] = useState<{ x: string, y: string }>({ x: '0', y: '0' });
  const [dragIconPos, setDragIconPos] = useState<{ x: string, y: string }>({ x: '0', y: '0' });
  // - Effect -
  // -- 表示位置の更新 --
  useEffect(() => {
    const setTooltip = (v: { type: 'imageHover' | 'frameMove' | 'scaleIcon' | 'rotateIcon' | 'none', pos: { x: number, y: number } }) => {
      setShowType(v.type);
      if (v.type === 'imageHover') {
        setImageHoverPos({ x: `${v.pos.x}px`, y: `${v.pos.y}px` });
      } else if (v.type === 'frameMove') {
        setFrameMovePos({ x: `${v.pos.x}px`, y: `${v.pos.y}px` });
      } else if (v.type === 'scaleIcon' || v.type === 'rotateIcon') {
        setDragIconPos({ x: `${v.pos.x}px`, y: `${v.pos.y}px` });
      } else {
        setShowType(v.type);
      }
    };
    TrimUiManager.ins.on('t->r:show-tooltip', setTooltip);
    return () => {
      TrimUiManager.ins.off('t->r:show-tooltip', setTooltip);
    };
  }, []);
  return (
    <div>
      {showType === 'imageHover' ?
        <StaticTooltip
          messages={['「ダブルクリック」でトリミング']}
          pos={imageHoverPos}
        />
        : showType === 'frameMove' ?
          <StaticTooltip
            messages={['エリア外をクリックすると', '移動モードが解除されます']}
            pos={frameMovePos}
          />
          : showType === 'scaleIcon' ?
            <StaticTooltip
              messages={['ドラッグして拡大・縮小します']}
              pos={dragIconPos}
            />
            : showType === 'rotateIcon' ?
              <StaticTooltip
                messages={['ドラッグして回転します']}
                pos={dragIconPos}
              />
              : <></>
      }
    </div>
  );
};
